import locations from '@/scripts/locations';
import { SITE_URL } from '@/scripts/site';

/**
 * Build Schema.org `Restaurant` JSON-LD (one node per location) for local-search rich results. Geo
 * coordinates are parsed from each location's Google Maps URL; address locality/region from
 * `city`.
 */
export function restaurantSchema(): object {
  const graph = locations.map((loc) => {
    const geo = loc.mapUrl.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
    const [locality, region] = loc.city.split(',').map((part) => part.trim());
    const digits = loc.phone.replace(/\D/g, '');
    const node: Record<string, unknown> = {
      '@type': 'Restaurant',
      name: `Albano's Villa — ${loc.name}`,
      servesCuisine: 'Italian',
      priceRange: '$$',
      url: `${SITE_URL}/locations`,
      telephone: `+1-${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`,
      address: {
        '@type': 'PostalAddress',
        streetAddress: loc.address,
        addressLocality: locality,
        addressRegion: region,
        addressCountry: 'US',
      },
      hasMap: loc.mapUrl,
    };
    if (geo) {
      node.geo = { '@type': 'GeoCoordinates', latitude: Number(geo[1]), longitude: Number(geo[2]) };
    }
    return node;
  });
  return { '@context': 'https://schema.org', '@graph': graph };
}
